// extracted by mini-css-extract-plugin
export var content = "_o8-1";
export var fullScreen = "_o8-0";